<script lang="ts">
    import getPercentClass from '@/utils/get-percent-class';
    import { componentTooltip } from '@/shared/utils/tooltips';
    import type { Character } from '@/types';
    import type { ManualDataProgressGroup } from '@/types/data/manual';
    import type { ProgressInfo } from '@/utils/get-progress';

    import TooltipProgress from '@/components/tooltips/progress/TooltipProgress.svelte';
    import WowthingImage from '@/shared/components/images/WowthingImage.svelte';

    type Props = {
        character: Character;
        group: ManualDataProgressGroup;
        progressData: ProgressInfo;
    };
    let { character, group, progressData }: Props = $props();
</script>

<style lang="scss">
    td {
        --max-width: var(--width-progress-max);
        --width: var(--width-progress);

        border-left: 1px solid var(--border-color);
        text-align: right;

        &.has-icon {
            --width: calc(var(--width-progress) + 2.8rem);
            --max-width: calc(var(--width-progress-max) + 2.8rem);
        }
        &.status-fail {
            text-align: center;
        }
        :global(img) {
            margin-right: 2px;
        }
    }
    span {
        flex: 1;
    }
</style>

{#if progressData?.total > 0}
    <td
        class="max-width"
        class:has-icon={!!progressData.icon}
        use:componentTooltip={{
            component: TooltipProgress,
            propsFunc: () => ({
                datas: progressData.datas,
                descriptionText: progressData.descriptionText,
                iconOverride: progressData.icon,
                nameOverride: progressData.nameOverride,
                showCurrencies: [progressData.showCurrency],
                statuses: progressData.statuses,
                character,
                group,
            }),
        }}
    >
        {#if progressData.icon}
            <WowthingImage name={progressData.icon} size={20} />
        {/if}

        <span
            class={progressData.missingRequired
                ? 'status-fail'
                : getPercentClass((progressData.have / progressData.total) * 100)}
        >
            {#if progressData.inProgress}
                {progressData.have}+{progressData.inProgress}
            {:else}
                {progressData.have}
            {/if}
            /
            {progressData.total}
        </span>
    </td>
{:else if progressData?.have === -1 && progressData?.total >= 0}
    <td class="status-fail">---</td>
{:else if (group.minimumLevel || 0) > character.level}
    <td class="status-fail">
        <span>{group.minimumLevel}+</span>
    </td>
{:else}
    <td>&nbsp;</td>
{/if}
